export default __webpack_public_path__ + "static/header-4c1964ef1dee546f78ae080bb29b6fc9.jpg";